// Woocommerce rest api
// Consumer-key: ck_3f64723de927fbc7222ad190a302069abbc4b808
// Consumer-secret: cs_ced5de8709330972a6605a37461cf6e682e22f0b
import cookiemanager from "./cookiemanager";

var savebasket = {
    test: "",
    init: function () {
        this.clickEvents();
    },
    clickEvents: function () {
        document.querySelectorAll('.save-basket').forEach((item) => {
            item.addEventListener('click', function (el) {
                el.preventDefault();
                savebasket.save();
            })
        });
        document.querySelectorAll('.load-basket').forEach((item) => {
            item.addEventListener('click', function (el) {
                el.preventDefault();
                var basketid = el.target.dataset.basketid;
                savebasket.load(basketid);
            })
        });
        const copyLinkBtn = document.getElementById('copyButton')
        if(copyLinkBtn != undefined){
            copyLinkBtn.addEventListener('click', copylinkbtnfunc);
            function copylinkbtnfunc() {
                savebasket.copyLink();
            }
        }

        //I hate that we have to use JQuery here but its linked so tightly with woocommerce cart events its inevitable :/
        //also the timeout is required as Woocommerce fires the event way earlier than needed.
        jQuery( document.body ).on( 'updated_cart_totals', function(){
            const instance = savebasket;
            const myTimeout = setTimeout(function(){
                document.querySelectorAll('.save-basket').forEach((item) => {
                    item.addEventListener('click', function (el) {
                        el.preventDefault();
                        instance.save();
                    })
                });
            }, 2000);

        });
    },
    save: function () {
        var formData = new FormData();
        formData.append("action", 'save_basket');
        formData.append("nonce", wp_ajax.nonce);
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = function () {
            if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                var results = JSON.parse(this.response);

                if (results.success) {
                    document.querySelector('.savedurl').textContent = 'Please save the URL to use later:' + results.url;
                    document.querySelector('.savedurl').setAttribute('href', results.url);
                    localStorage.setItem("lsSavedURL", results.url);
                    window.location = results.url;
                }

            }
        };
        xmlHttp.open("post", wp_ajax.url);
        xmlHttp.send(formData);
    },
    load: function (basketkey) {
        var formData = new FormData();
        formData.append("action", 'load_basket');
        formData.append("nonce", wp_ajax.nonce);
        formData.append("basketkey", basketkey);
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = function () {
            if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                var results = JSON.parse(this.response);
                if (results.success) {
                    if (cookiemanager.setCookie('original_basket', results.basketkey, 10)) {
                        window.location.href = '/basket/';
                    } else {
                        console.log("Cookie Error");
                    }
                }

            }
        };
        xmlHttp.open("post", wp_ajax.url);
        xmlHttp.send(formData);
    },

    copyLink: function () {
            /* Get the text input element */
            var copyText = document.getElementById("copyInput");
          
            /* Select the text in the input element */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices */
          
            /* Copy the selected text to the clipboard */
            document.execCommand("copy");
          
            /* Alert the user that the text has been copied */
            alert("Text copied to clipboard: " + copyText.value);
          
    }

}

export default savebasket;

